<template>
  <div class="vote">
    <button v-bind:class="{'voteBtn': true,  low: true, active: nowVote == 'low', 'nonActive': nowVote == 'high' || disabled == true}" @click="vote('low')">
      <img src="../assets/arrow.svg"/>
    </button>
    <button v-bind:class="{'voteBtn': true,  high: true, active: nowVote == 'high', 'nonActive': nowVote == 'low' || disabled == true}" @click="vote('high')">
      <img src="../assets/arrow.svg"/>
    </button>
    <div class="reCaptchaInfo">
      This site is protected by reCAPTCHA and the Google
      <a href="https://policies.google.com/privacy">Privacy Policy</a> and
      <a href="https://policies.google.com/terms">Terms of Service</a> apply.
    </div>
    <Modal title="投票完了" text="あなたの投票をみんなにシェアしよう！" btn="ツイートする" v-bind:tweet="tweetText" v-bind:active="modal" @close="closedModal" />
  </div>
</template>

<script>
/* global grecaptcha */
import firebase from 'firebase/app'
import moment from 'moment-timezone'
import Modal from './Modal'

moment.tz.setDefault('Asia/Tokyo')

export default {
  name: 'Vote',
  components: {
    Modal
  },
  props: ['targetTime'],
  data () {
    return {
      name: firebase.auth().currentUser.displayName,
      nowVote: null,
      token: null,
      recaptchaReady: false,
      disabled: true,
      modal: false,
      tweetText: 'テスト'
    }
  },
  mounted: function () {
    this.getVote()
    grecaptcha.ready(() => {
      this.recaptchaReady = true
    })
    setInterval(() => {
      let countDown = moment(this.targetTime * 1000).utc() - moment().utc()
      if (countDown < 0) {
        this.disabled = true
      } else {
        this.disabled = false
      }
    }, 1000)
  },
  methods: {
    vote: function (_vote) {
      this.$ga.event('vote', 'click_vote', _vote, _vote === 'high' ? 1 : 0)
      let oldVote = this.nowVote
      if (!this.recaptchaReady) {
        alert('初期化中。少し後にお試しください。')
      } else {
        this.nowVote = _vote
        grecaptcha.execute('6Lf_yn4UAAAAAJKHKasZsn812mqd3Sw_F5TTAcCh', {action: 'homepage'}).then(token => {
          this.token = token
          if (this.token) {
            let minute = +(moment().format('mm'))
            if ((minute >= 0 && minute < 20) || (minute >= 30 && minute < 50)) {
              var postVote = firebase.functions().httpsCallable('postVote')
              postVote({vote: _vote, response: this.token}).then(result => {
                this.nowVote = _vote
                if (_vote === 'high') {
                  this.tweetText = '私は上がるに投票しました！ | 無料でビットコインが貰えるアプリ「ぴたコイン」'
                } else {
                  this.tweetText = '私は下がるに投票しました！ | 無料でビットコインが貰えるアプリ「ぴたコイン」'
                }
                this.modal = true
              })
            } else {
              this.nowVote = oldVote
              alert('投票時間が過ぎています。')
            }
          } else {
            this.nowVote = oldVote
            alert('error reCAPTCHA')
          }
        })
      }
    },
    closedModal: function () {
      this.modal = false
    },
    getVote: function () {
      const db = firebase.firestore()
      let date = Date.now()
      let tarm = moment(Math.floor((date) / 1000 / 60 / 30) * 1000 * 60 * 30)
      db.collection('tarmData').doc(tarm.format('YYYYMMDD_HHmm')).collection('vote').doc(firebase.auth().currentUser.uid)
        .get().then(doc => {
          if (doc.exists) {
            this.nowVote = doc.data().vote
          }
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.voteBtn{
  border: none;
  display: inline-block;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.25);
  background: #fff;
  cursor: pointer;
  transition: 200ms linear opacity;
  margin: 20px 12px 0;
}
.voteBtn:hover{
  opacity: 0.8;
}
.voteBtn img{
  position: relative;
  top: 4px;
}
.voteBtn.active{
  width: 150px;
  height: 150px;
}
.nonActive{
  opacity: 0.3;
  background: #999 !important;
}
.voteBtn.high{
  background: #00A6FB;
  transform: rotate(180deg);
}
.voteBtn.low{
  background: #FE4A49
}
.reCaptchaInfo{
  padding-top: 10px;
  font-size: 10px;
  margin-bottom: 20px;
}
@media all and (max-width: 740px) {
  .voteBtn{
    width: 72px;
    height: 72px;
  }
  .voteBtn:hover{
    opacity: 1;
  }
  .voteBtn img{
    width: 35px;
    top: 2px;
  }
  .voteBtn.active{
    width: 90px;
    height: 90px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Vote.vue